const ACCESS_KEY = 'momy.accessToken';
const REFRESH_KEY = 'momy.refreshToken';
const LOGIN_KEY = 'momy.login';

export function readStorage(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage indisponivel */
  }
}

export function removeStorage(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* storage indisponivel */
  }
}

export function getAccessToken(): string | null {
  const raw = readStorage(ACCESS_KEY);
  if (!raw) return null;
  if (raw.startsWith('"') && raw.endsWith('"')) {
    try {
      return JSON.parse(raw) as string;
    } catch {
      return raw;
    }
  }
  return raw;
}

export function getRefreshToken(): string | null {
  return readStorage(REFRESH_KEY);
}

export function setTokens(accessToken: string, refreshToken: string): void {
  writeStorage(ACCESS_KEY, accessToken);
  writeStorage(REFRESH_KEY, refreshToken);
}

export function clearTokens(): void {
  removeStorage(ACCESS_KEY);
  removeStorage(REFRESH_KEY);
}

export function getRememberedLogin(): string | null {
  return readStorage(LOGIN_KEY);
}

export function setRememberedLogin(login: string | null): void {
  if (login) {
    writeStorage(LOGIN_KEY, login);
  } else {
    removeStorage(LOGIN_KEY);
  }
}

export function clearSessionStorage(): void {
  clearTokens();
}
